import { Button, Dialog, Dropdown, Text } from "@100mslive/react-ui";
import {
  DialogContent,
  DialogInput,
  DialogRow,
} from "../../primitives/DialogContent";
import React, { useState } from "react";
import {
  useResetEmbedConfig,
  useSetAppDataByKey,
} from "../AppData/useUISettings";

import { APP_DATA } from "../../common/constants";
import { ViewIcon } from "@100mslive/react-icons";
import { useScreenShare } from "@100mslive/react-sdk";
import { useTranslation } from "react-i18next";

export const EmbedUrl = ({ setShowOpenUrl }) => {
  const { amIScreenSharing } = useScreenShare();
  const { t } = useTranslation();
  if (!window.CropTarget) {
    return null;
  }
  return (
    <Dropdown.Item
      onClick={() => {
        if (!amIScreenSharing) {
          setShowOpenUrl(true);
        }
      }}
      disabled={amIScreenSharing}
      data-testid="embed_url_btn"
    >
      <ViewIcon />
      <Text variant="sm" css={{ ml: "$4" }}>
        {t("lbl_url_embed")}
      </Text>
    </Dropdown.Item>
  );
};

export function EmbedUrlModal({ onOpenChange }) {
  const { t } = useTranslation();
  const [embedConfig, setEmbedConfig] = useSetAppDataByKey(
    APP_DATA.embedConfig
  );
  const [url, setUrl] = useState(embedConfig || "");

  const isAnythingEmbedded = !!embedConfig;
  const isModifying = isAnythingEmbedded && url && url !== embedConfig;
  const resetConfig = useResetEmbedConfig();
  return (
    <Dialog.Root defaultOpen onOpenChange={onOpenChange}>
      <DialogContent title={t("lbl_url_embed")} Icon={ViewIcon}>
        <DialogInput
          title="URL"
          value={url}
          onChange={setUrl}
          placeholder="https://www.tldraw.com/"
          type="url"
        />
        <DialogRow>
          <Text>{t("msg_embed")}</Text>
        </DialogRow>
        <DialogRow justify="end">
          {isAnythingEmbedded ? (
            <>
              <Button
                variant="primary"
                type="submit"
                disabled={!isModifying}
                onClick={() => {
                  setEmbedConfig(url);
                  onOpenChange(false);
                }}
                data-testid="embed_url_btn"
                css={{ mr: "$4" }}
              >
                {t("lbl_update_embed")}
              </Button>
              <Button
                variant="danger"
                type="submit"
                onClick={() => {
                  resetConfig();
                  onOpenChange(false);
                }}
                data-testid="embed_url_btn"
              >
                {t("lbl_stop_embed")}
              </Button>
            </>
          ) : (
            <Button
              variant="primary"
              type="submit"
              disabled={!url.trim()}
              onClick={() => {
                setEmbedConfig(url);
                onOpenChange(false);
              }}
              data-testid="embed_url_btn"
            >
              {t("lbl_embed_and_share")}
            </Button>
          )}
        </DialogRow>
      </DialogContent>
    </Dialog.Root>
  );
}
